import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { LeadStageOptions } from '../services/entity';
export default function LeadStageToggleButton(props) {
    var _value$name;
    var value = props.value, onChange = props.onChange, _a = props.name, name = _a === void 0 ? '' : _a;
    var options = LeadStageOptions;
    var currValue = value === null || value === void 0 || (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.id;
    return /*#__PURE__*/ React.createElement(ToggleButtonGroup, {
        exclusive: true,
        size: "small",
        color: "primary",
        onChange: function (e, val) { return onChange === null || onChange === void 0 ? void 0 : onChange(e, options[val]); },
        value: currValue
    }, options.map(function (stage) { /*#__PURE__*/ return React.createElement(ToggleButton, {
        value: stage === null || stage === void 0 ? void 0 : stage.id,
        key: stage === null || stage === void 0 ? void 0 : stage.id,
        disableRipple: true,
        color: "info",
        size: "small",
        sx: {
            px: 1.5,
            py: 0.75,
            borderRadius: 2,
            fontSize: 'base',
            fontWeight: 'medium',
            textTransform: 'none'
        }
    }, stage === null || stage === void 0 ? void 0 : stage.Name); }));
}
